<template>

  <div id="data-list-list-view" class="data-list-container ">

    <vs-table
      :sst="true"
      stripe
      @search="handleSearch"
      @sort="handleSort"
      max-items="20"
      search
      noDataText="No se encontraron datos"
      :data="invoicesData">

      <template slot="thead">
        <vs-th sort-key="name">
          Concepto
        </vs-th>
        <vs-th sort-key="rfc">
          Estado
        </vs-th>
        <vs-th sort-key="role">
          Cantidad
        </vs-th>
        <vs-th sort-key="created_at">
          Fecha
        </vs-th>
        <vs-th>
          Acciones
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

          <vs-td :data="tr.name">
            {{tr.name}}
          </vs-td>

          <vs-td :data="tr.status">
            {{invoice_status[tr.status]}}
          </vs-td>

          <vs-td :data="tr.amount">
            {{tr.amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}}
          </vs-td>

          <vs-td :data="tr.created_at">
            {{new Date(tr.created_at).toLocaleString()}}
          </vs-td>

          <vs-td>
            <vs-button v-if="tr.status === 'CREATED'" @click="openTaxDataSelector(tr.id)">Facturar</vs-button>
            <vs-button class="mr-2 btn-secundary" v-if="tr.status === 'ISSUED'" @click="downloadXmlPdf(tr.id, 'xml')">XML</vs-button>
            <vs-button v-if="tr.status === 'ISSUED'" @click="downloadXmlPdf(tr.id, 'pdf')">PDF</vs-button>
            <span v-if="tr.status === 'GLOBAL_ISSUED'">No se puede facturar</span>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
    <br>
    <vs-pagination :total="getTotalPages" v-model="currentPage" @input="handleChangePage"></vs-pagination>


    <vs-popup title="Selecciona los datos de facturación que deseas usar" :active.sync="taxDataPopup">
      <div v-if="!taxData.length" class="mx-4">No cuentas con datos de facturación en tu cuenta, da clic en el siguiente enlace para poder agregarlos. Clic <span @click="goToTaxData" style="color: #7367f0; cursor: pointer; text-decoration: underline;">aquí</span>.</div>
      <img v-if="!taxData.length" src="@/assets/images/pages/error.svg" alt="workspace" width="400" class="center-element my-5">
      <vs-card v-if="taxData.length" v-for="item in taxData" :key="item.id">
        <div slot="header">
          <h3>
            {{ item.company }}
          </h3>
        </div>
        <div>
          <b>RFC: </b><span>{{ item.rfc }}</span>
          <br>
          <b>Uso de CFDI: </b><span>{{ item.use_cfdi }}</span>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button type="filled" color="primary" @click="bill(item.id)">Seleccionar</vs-button>
          </vs-row>
        </div>
      </vs-card>
    </vs-popup>

  </div>

</template>

<script>
import moment from "moment";
import {API_URL, INVOICE_STATUS} from "../../../../config/app";

export default {
  name: "AllInvoicesList",
  data: () => ({
    currentPage: 1,
    searching: '',
    sort: {
      key: null,
      active: null
    },
    addNewDataSidebar: false,
    sidebarData: {},
    api_url: API_URL,
    taxDataPopup: false,
    invoiceSelected: null,
    invoice_status: INVOICE_STATUS
  }),
  computed: {
    invoicesData() {
      return this.$store.state.invoices.invoices.data;
    },
    getTotalPages() {
      return this.$store.state.invoices.invoices.pagination.total
    },
    taxData() {
      return this.$store.state.taxData.taxData.data;
    },
    getDate() {
      return moment().format("Y-m-dTH:i:sP.");
    },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    }
  },
  methods: {
    goToTaxData() {
      this.taxDataPopup = false;
      this.$router.push('/configuration/tax-data');
    },
    bill(taxDataId) {
      let invoiceId = this.invoiceSelected;
      this.$vs.loading({type: "point"})
      this.$store.dispatch("invoices/bill", {taxDataId: taxDataId, invoiceId: invoiceId})
      .then(
        () => {
          this.$vs.loading.close()
          this.taxDataPopup = false;
        }
      )
    },
    openTaxDataSelector(invoiceId) {
      this.invoiceSelected = invoiceId;
      this.taxDataPopup = true;
    },
    downloadXmlPdf(invoiceId, type) {
      this.$store.dispatch("invoices/downloadPdfXml", {invoiceId: invoiceId, type: type});
    },
    handleSearch(searching) {
      this.searching = searching;
      if (this.sort.active === 'desc') {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
      } else if (this.sort.active === 'asc') {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: searching, sort: this.sort.key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: searching}).catch(err => { console.error(err) })
      }
    },
    handleChangePage(page) {
      this.currentPage = page;
      if (this.sort.active === 'desc') {
        this.$store.dispatch('invoices/getAll', {page: page - 1, search: this.searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
      } else if (this.sort.active === 'asc') {
        this.$store.dispatch('invoices/getAll', {page: page - 1, search: this.searching, sort: this.sort.key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('invoices/getAll', {page: page - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    },
    handleSort(key, active) {
      this.sort = {key, active};
      if (active === 'desc') {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: this.searching, sort: "-" + key}).catch(err => { console.error(err) })
      } else if (active === 'asc') {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: this.searching, sort: key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    }
  },
  created() {
    this.$store.dispatch('invoices/getAll', {page: this.currentPage - 1}).catch(err => { console.error(err) })
    this.$store.dispatch("taxData/getAll", {page: 0})
  }
}
</script>

<style lang="scss">
#data-list-list-view {

  .name-w{
    width: 25%;
  }
  .mail-w{
    width: 25%;
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
